import React from 'react';
export function SubscriberTagIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 8.722V6.85C6 5.197 7.41 4 9 4a1 1 0 000-2h-.15A4.85 4.85 0 004 6.85v1.872c0 1.296.407 2.59 1.268 3.585C3.473 12.957 2 14.61 2 17v4c0 .318.121.557.304.718.18.175.426.282.696.282h12a1 1 0 001-1v-4c0-3.132-2.531-5-5-5a1 1 0 100 2c1.531 0 3 1.132 3 3v3H4v-3c0-1.868 1.469-3 3-3a1 1 0 001-1v-.5c0-.5-.081-.633-.459-.876a26.64 26.64 0 01-.166-.108C6.49 10.938 6 9.911 6 8.722zM16 6a1 1 0 11-2 0 1 1 0 012 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.663 2.006a1.945 1.945 0 011.377.571v.001l3.257 3.26a2.421 2.421 0 01-.004 3.424l-3.046 3.035a2.424 2.424 0 01-3.427-.005l-3.256-3.26-.002-.001a1.952 1.952 0 01-.568-1.375v-.002L11 3.946a1.946 1.946 0 011.951-1.945l3.713.005zm-.023 2L12.998 4l-.004 3.633 3.241 3.245a.424.424 0 00.6 0l3.046-3.034a.42.42 0 00.001-.594L16.64 4.006z"
  }));
}